<section class="page-goldn">
  <div class="container">
    <header class="goldn-header">

      <div class="back-navigation-bar">
        <div class="container">
          <gob-back (back)="goBack()"></gob-back>
        </div>
      </div>
      
      <div class="title-wrapper">
        <h1 class="main-title">GOLD'N GOB</h1>
      </div>
      <h2 class="sub-title">Un prix ludique alliant expertise et passion du public !</h2>

      <div class="process-steps">
        <div class="step-card">
          <div class="step-number">1</div>
          <h3>La Sélection</h3>
          <p>Le principe des Gold'n Gob est axé sur une sélection rigoureuse de jeux, effectuée par des <strong>professionnels du secteur</strong>. Cette dynamique permet de valoriser les créations les plus innovantes.</p>
        </div>

        <div class="step-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
        </div>

        <div class="step-card">
          <div class="step-number">2</div>
          <h3>Les Nominations</h3>
          <p>Lors des <strong>Jeux du Graoully</strong> et des <strong>Jeux du Roc</strong>, les jeux sont soumis aux <strong>votes du public</strong>. C'est vous, les festivaliers, qui choisissez les finalistes !</p>
        </div>

        <div class="step-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
        </div>

        <div class="step-card highlight">
          <div class="step-number">3</div>
          <h3>Les Lauréats</h3>
          <p>Le suspense prend fin en fin d'année ! Les gagnants de chaque catégorie reçoivent le prestigieux label <strong>Gold'n Gob</strong>, gage de qualité et de plaisir ludique.</p>
        </div>
      </div>
    </header>

    <div class="historique-section" *ngIf="!loading">
      <div *ngFor="let promo of historique" class="annee-block">
        <div class="annee-info">
          <h3 class="titre-annee">Les Lauréats {{ promo.annee }}</h3>
          <span class="nb-cat">{{ promo.nbCategories }}</span>
          <p class="details-cat">{{ promo.details }}</p>
        </div>

        <div class="carousel-wrapper">
          <button (click)="scrollListe(listeRef, 'gauche')" class="nav-arrow prev mobile-only-flex">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </button>

          <div class="liste-jeux" #listeRef (scroll)="gererScrollInfini($event)">
            <div *ngFor="let jeu of promo.jeux" class="jeu-card-container">
              <a [routerLink]="route.parse('product', [jeu.ident])" class="jeu-item">
                <div class="img-wrapper">
                  <img [src]="imageErrors[jeu.ident] ? 'assets/img/logo/logo.png' : jeu.img" 
                      (error)="onImageError(jeu.ident)" 
                      [alt]="jeu.nom">
                </div>
                <span class="nom-jeu">{{ jeu.nom }}</span>
              </a>
              <div class="badge-gamme-wrapper">
                <span class="badge-gamme">{{ jeu.gamme }}</span>
              </div>
            </div>
          </div>

          <button (click)="scrollListe(listeRef, 'droite')" class="nav-arrow next mobile-only-flex">
            <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>